module.exports = "data:application/font-woff;base64,"